export const DCustomer = {
    id: -1,
    name: "",
    email: "",
    credit: 0
}
